import { render, staticRenderFns } from "./longTextComponent.vue?vue&type=template&id=f2eccb84&scoped=true&"
import script from "./longTextComponent.vue?vue&type=script&lang=js&"
export * from "./longTextComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2eccb84",
  null
  
)

export default component.exports